export type CoverageInsuranceType = 'NONE' | 'INSURANCE' | 'REINSURANCE' | 'INREINSURANCE'

export const COVERAGE_INSURANCE_TYPE_OPTIONS: { label: string; value: CoverageInsuranceType }[] = [
  { label: 'None', value: 'NONE' },
  { label: 'Insurance', value: 'INSURANCE' },
  { label: 'Reinsurance', value: 'REINSURANCE' },
  { label: 'Insurance/Reinsurance', value: 'INREINSURANCE' }
]

/** A template always targets an actual coverage type, so `NONE` is not selectable there. */
export const SELECTABLE_COVERAGE_INSURANCE_TYPE_OPTIONS = COVERAGE_INSURANCE_TYPE_OPTIONS.filter(option => option.value !== 'NONE')
